import React from 'react';
import { Typography, TextField } from '@material-ui/core';
import { ICustomTextFieldProps } from './Components';
import { useStyles } from './CustomTextField.style';

const CustomTextField: React.FC<ICustomTextFieldProps> = React.memo(
  ({
    onChange,
    label,
    hiddenLabel,
    required,
    autoComplete,
    autoFocus,
    color,
    defaultValue,
    disabled,
    error,
    fullWidth,
    helperText,
    id,
    InputProps,
    InputLabelProps,
    inputRef,
    margin,
    multiline,
    name,
    placeholder,
    rows,
    rowsMax,
    select,
    SelectProps,
    type,
    value,
    tooltip,
    children,
  }: ICustomTextFieldProps) => {
    const classes = useStyles();

    return (
      <>
        <div hidden={hiddenLabel}>
          <Typography
            variant="caption"
            display="block"
            className={classes.label}
          >
            {label} {tooltip}
          </Typography>
        </div>

        <TextField
          className={classes.textField}
          variant="outlined"
          size="small"
          onChange={onChange}
          required={required}
          autoComplete={autoComplete}
          autoFocus={autoFocus}
          color={color}
          defaultValue={defaultValue}
          disabled={disabled}
          error={error}
          FormHelperTextProps={{
            className: classes.formHelperText,
          }}
          fullWidth={fullWidth}
          helperText={helperText}
          id={id}
          InputProps={InputProps}
          InputLabelProps={InputLabelProps}
          inputRef={inputRef}
          margin={margin}
          multiline={multiline}
          name={name}
          placeholder={placeholder}
          rows={rows}
          rowsMax={rowsMax}
          select={select}
          SelectProps={SelectProps}
          type={type}
          value={value}
        >
          {children}
        </TextField>

      </>
    );
  },
);

export default CustomTextField;
